const data = [
	{
		NITTTR: `Completed One week Short Term Training Program on “ Engineering Capstone 
		Projects”`,
	},
	{
		NITTTR: `Completed One week Short Term Training Program on “ Online Pedeagogy”
		`,
	},
	{
		NITTTR: `Completed One week Short Term Training Program on “ Teaching Learning Process 
		using Instructional Media”`,
	},
	{
		NITTTR: `Completed One week Short Term Training Program on “ Artificial Intelligence”
		`,
	},
	{
		NITTTR: `Completed One week Short Term Training Program on “ Communication & 
		Presentation Skill”
		`,
	},
	{
		NITTTR: `Completed One week Short Term Training Program on “ Data Analytics using 
		Python”`,
	},
	{
		NITTTR: `Completed One week Short Term Training Program on “ Data Science using R”`,
	},
	{
		NITTTR: `Completed One week Short Term Training Program on “ Evaluation & Question 
		Paper setting”`,
	},
	{
		NITTTR: `Completed One week Short Term Training Program on “ Outcome Based Education”
		`,
	},
	{
		NITTTR: `Completed One week Short Term Training Program on “ Problem Based Learning”`,
	},
	{
		NITTTR: ` Completed One week Short Term Training Program on “ Data Analytics using 
		Python”`,
	},
	{
		NITTTR: `Completed One week Short Term Training Program on “ NBA & SAR Preparation”`,
	},
	{
		NITTTR: `Completed One week Short Term Training Program on “ Skill Enhancement using 
		free Open Source Tools”
		`,
	},
	{
		NITTTR: `Completed One week Short Term Training Program on “Unnat Bharat Abhiyan”`,
	},
	{
		NITTTR: `Completed One week Short Term Training Program on “ Machine Learning & 
		Predictive Analysis”
		`,
	},
];

export default data;
